import { connect } from 'react-redux';

import { JWT } from 'constants/system';

import { getCookie } from 'utils/cookies';

export default connect(
  ({
    user: {
      expiresAt,
      type,
      activeUserType,
      studentPreviewCounselor = {},
      isAlumni,
      moduleAccess,
      isMember,
      affiliations,
      userCapabilities,
      isDemoDistrict,
      isCounselor,
      ...rest
    },
  }) => {
    const isOAuth2Authenticated = type === 'guest' && getCookie(JWT);

    const isLoggedIn = type !== 'guest';
    const isStudent = type.includes('student');
    const isGuardian = type.includes('guardian');
    const isLorWriter = type.includes('recommender');
    const isSupervisor = type.includes('supervisor');
    const isDemoStudent =
      type.includes('student') &&
      Object.keys(studentPreviewCounselor).length > 0;

    const isCounselorActive =
      activeUserType.includes('school_admin') ||
      activeUserType.includes('k12_admin');
    const isStudentActive = activeUserType.includes('student');
    const isGuardianActive = activeUserType.includes('guardian');
    const isLorWriterActive = activeUserType.includes('recommender');
    const isSupervisorActive = activeUserType.includes('supervisor');
    const isMemberActive = activeUserType.includes('member');

    return {
      moduleAccess,
      user: {
        type,
        activeUserType,
        expiresAt,
        affiliations,
        isLoggedIn,
        isCounselor,
        isStudent,
        isGuardian,
        isLorWriter,
        isSupervisor,
        isMember,
        isMemberActive,
        isDemoStudent,
        isDemoDistrict,
        isOAuth2Authenticated,
        isAlumni,
        isCounselorActive,
        isStudentActive,
        isGuardianActive,
        isLorWriterActive,
        isSupervisorActive,
        ...rest,
      },
    };
  },
  () => ({}),
);
